import React, {Component} from "react";
import {connect} from "react-redux";

import {onNavStyleChange, toggleCollapsedSideNav} from "appRedux/actions/Setting";
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  TAB_SIZE,
} from "../../constants/ThemeSetting";


class SidebarLogo extends Component {

  render() {
    const {width} = this.props;
    let {navStyle} = this.props;
    if (width < TAB_SIZE && navStyle === NAV_STYLE_FIXED) {
      navStyle = NAV_STYLE_DRAWER;
    }
    return (
      <div className="gx-layout-sider-header my-logo-container">
        {this.props.collapsed
          ? <img src="/logo-short-dark.svg" width="34" height="24" alt="2way" />
          : <img src="/logo-dark.svg" width="104" height="29" alt="2way" />}
      </div>
    );
  }
}

const mapStateToProps = ({settings}) => {
  const {navStyle, themeType, width, navCollapsed} = settings;
  return {navStyle, themeType, width, navCollapsed}
};

export default connect(mapStateToProps, {
  onNavStyleChange,
  toggleCollapsedSideNav
})(SidebarLogo);
